import API from './base';

class ExamCentersSearchAPI extends API {
  apiBase = '/api/exam_centers';

  getExamCentersByCoordinates(latitude, longitude, radius) {
    const today = new Date();
    const examCentersQueryParams = new URLSearchParams({
      latitude,
      longitude,
      timezone: today.getTimezoneOffset(),
    });

    if (radius) {
      examCentersQueryParams.append('radius', radius);
    }

    return this.get(this.apiBase, examCentersQueryParams);
  }

  getExamCentersByDepartmentAndCity(department, city) {
    const examCentersQueryParams = new URLSearchParams({
      department,
    });
    if (city) { examCentersQueryParams.append('city', city); }

    return this.get(this.apiBase, examCentersQueryParams);
  }
}

export default new ExamCentersSearchAPI();
